import { AES, enc } from 'crypto-js';
import { AES_KEY } from '../constant';
class Aes {
    /**
     * 加密
     * @param data
     * @returns
     */
    encrypt(data) {
        const datastr = JSON.stringify(data);
        return AES.encrypt(datastr, AES_KEY).toString();
    }
    /**
     * 解密
     * @param ciphertext
     * @returns
     */
    decrypt(ciphertext) {
        const bytes = AES.decrypt(ciphertext, AES_KEY);
        return JSON.parse(bytes.toString(enc.Utf8));
    }
}
export default new Aes();
//# sourceMappingURL=aes.js.map